<template>
  <modal show-close-btn @leave="$emit('leave')" width="240px">
    <div>
      <h2 class="mb-6">Custom Filter</h2>
      <p>* Please provide your custom filter as formatted in your CRM system to ensure it can be matched against.</p>
      <div class="flex flex-wrap -mx-2 mt-4">
        <div class="w-full px-2 mb-6">
          <label></label>
          <input type="text" v-model="name" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" placeholder="Type here..." />
          <span v-if="errorMessage" class="block text-red text-medium mt-2">{{ errorMessage }}</span>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 mt-4">
        <div class="flex-1 w-full lg:w-1/2 px-2"></div>
        <div class="flex-1 w-full lg:w-1/2 px-2 justify-end">
          <button @click="submitBlankFilter" class="bg-grey-lighter rounded py-3 px-6">
            <span>Create Blank Filter</span>
          </button>
          <button @click="submitFilter" class="bg-primary rounded py-3 px-6 text-white ml-4">
            <span>Create Filter</span>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      errorMessage: ''
    }
  },
  methods: {
    submitFilter () {
      if (!this.name.trim()) {
        this.errorMessage = 'Please enter the filter name.'
        return
      }

      this.errorMessage = ''
      this.$emit('saveFilter', this.name)
    },
    submitBlankFilter () {
      this.errorMessage = ''
      this.$emit('saveFilter', '')
    }
  }
}
</script>
